import React from 'react';
import '../style/loading.scss'
import FloatingFlag from './floatingFlag'
function Loading(props) {
  return (
    <div className="loading">
      <div className="loading-step1">
        <FloatingFlag startLoading={props.startLoading} totalPercent={props.totalPercent} />
        <div className={`percent ${props.totalPercent === 100 ? 'hide' : ''}`}>
          {props.totalPercent}%
        </div>
      </div>
      <div className="cover"></div>
      <div className="enter-btn" onClick={props.loadingEnter} style={{ 'display': props.totalPercent === 100 ? 'block' : 'none' }}></div>
    </div>
  )
}

export default Loading;
